module.exports = __webpack_public_path__ + "fonts/PT_Sans-CaptionRegular.0308137f.woff2";